import {
  useAllPodcastSocialStatsSummary,
  useGetPodcastSocialStatsSummary,
  useGetPodcastYoutubeStatsSummary,
  useAllPodcastsYoutubeStatsSummary,
  useGetSocialStatsSummary,
} from 'pages/headliner/state';

interface UseSocialShareStatsByRssConfig {
  podcastId: string | undefined;
  episodeId: string | undefined;
  view: 'allPodcasts' | 'podcast' | 'episode';
}

export function useSocialShareStatsByRss({
  view,
  podcastId,
  episodeId,
}: UseSocialShareStatsByRssConfig) {
  const { data: allStats } = useAllPodcastSocialStatsSummary();

  const { data: allYouTubeStats } = useAllPodcastsYoutubeStatsSummary();

  const { data: episodeStats } = useGetSocialStatsSummary(episodeId);
  const [episodeSocialStats, episodeYoutubeStats] = episodeStats ?? [];

  const { data: singlePodcastSummary } =
    useGetPodcastSocialStatsSummary(podcastId);

  const { data: singlePodcastYoutubeSummary } =
    useGetPodcastYoutubeStatsSummary(podcastId);

  if (view === 'allPodcasts') {
    return { summaryStats: allStats, youtubeSummaryStats: allYouTubeStats };
  }

  if (view === 'podcast') {
    return {
      summaryStats: singlePodcastSummary,
      youtubeSummaryStats: singlePodcastYoutubeSummary,
    };
  }

  return {
    summaryStats: episodeSocialStats,
    youtubeSummaryStats: episodeYoutubeStats,
  };
}
